import type { Character } from "../types/character";
import { ALL_CHARACTERS } from "../types/character";

export function reachesFinish(position: number, trackLength: number): boolean {
  return position >= trackLength;
}

export function clampRacePosition(
  position: number,
  trackLength: number,
): number {
  return Math.min(position, trackLength);
}

export function findFinisher(
  positions: Readonly<Record<Character, number>>,
  trackLength: number,
): Character | null {
  for (const character of ALL_CHARACTERS) {
    if (reachesFinish(positions[character], trackLength)) {
      return character;
    }
  }
  return null;
}
